var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.indexCurrent == 0 ? "allFrom-one" : "allFrom",
        _vm.forget || _vm.indexCurrent == 4 ? "allFrom-forget" : ""
      ],
      attrs: { id: "loginForm" }
    },
    [
      _vm.indexCurrent < 3
        ? _c(
            "div",
            { staticClass: "tabs-scroll" },
            [
              _vm._l(_vm.tabs, function(tab, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "tabs-label",
                    on: {
                      click: function($event) {
                        _vm.indexCurrent = index
                      }
                    }
                  },
                  [_vm._v(_vm._s(tab.name))]
                )
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "login-tab-bar tab-bar-position",
                class: [
                  0 == _vm.indexCurrent ? "login-bar-one" : "",
                  1 == _vm.indexCurrent ? "login-bar-two" : ""
                ]
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "without-signing",
                  on: {
                    click: function($event) {
                      return _vm.createTouristLogin()
                    }
                  }
                },
                [
                  _vm._v(
                    _vm._s(_vm.$t("language.login.experienceSigning")) + " >"
                  )
                ]
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.indexCurrent == 0
        ? _c("div", { staticClass: "login-body" }, [
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email"
                    }
                  ],
                  staticClass: "signInInfo",
                  attrs: {
                    type: "text",
                    name: "email",
                    placeholder: _vm.$t("language.login.email")
                  },
                  domProps: { value: _vm.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password,
                      expression: "password"
                    }
                  ],
                  staticClass: "signInInfo",
                  attrs: {
                    type: "password",
                    name: "password",
                    placeholder: _vm.$t("language.login.password")
                  },
                  domProps: { value: _vm.password },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.password = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { width: "100%", height: "20px" } }, [
              _c("div", {
                staticClass: "icon-util",
                class: _vm.remenberPass ? "check-small" : "nocheck-small",
                staticStyle: {
                  position: "relative",
                  top: "1px",
                  float: "left",
                  "margin-right": "5px"
                },
                on: {
                  click: function($event) {
                    _vm.remenberPass = !_vm.remenberPass
                  }
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "remember-me" }, [
                _vm._v(_vm._s(_vm.$t("language.login.rememberMe")))
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "forget-pass",
                  on: {
                    click: function($event) {
                      _vm.indexCurrent = 4
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.login.forgotPassword")))]
              )
            ]),
            _vm._v(" "),
            _vm.forget
              ? _c("div", { staticClass: "sign-line" }, [
                  _c("div", { staticClass: "sign-input" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.verification,
                          expression: "verification"
                        }
                      ],
                      staticClass: "eac-input-wrap",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t("language.login.verificationCode")
                      },
                      domProps: { value: _vm.verification },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.verification = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.refresh
                    ? _c("img", {
                        staticClass: "verificationCode",
                        attrs: { src: _vm.ficationCode },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.refreshAndClearCode()
                          }
                        }
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "login-sure", staticStyle: { float: "left" } },
              [
                _c(
                  "button",
                  {
                    staticClass: "login",
                    on: {
                      click: function($event) {
                        return _vm.login()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.login.signIn")))]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line sign-line-one" }, [
              _c("span", [
                _c("a", {
                  staticClass: "login-google",
                  on: {
                    click: function($event) {
                      return _vm.thirdLogin("google_drive")
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("span", [
                _c("a", {
                  staticClass: "login-facebook",
                  on: {
                    click: function($event) {
                      return _vm.thirdLogin("facebook")
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "login-with" }, [
                _vm._v(_vm._s(_vm.$t("language.login.loginWith")))
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.indexCurrent == 1
        ? _c("div", { staticClass: "login-body" }, [
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nEmail,
                      expression: "nEmail"
                    }
                  ],
                  staticClass: "signInInfo",
                  attrs: {
                    type: "text",
                    name: "username",
                    placeholder: _vm.$t("language.login.email")
                  },
                  domProps: { value: _vm.nEmail },
                  on: {
                    blur: function($event) {
                      return _vm.emailOnblur()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nEmail = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.firstName,
                      expression: "firstName"
                    }
                  ],
                  staticClass: "first-name",
                  attrs: {
                    type: "text",
                    name: "password",
                    placeholder: _vm.$t("language.login.firstName")
                  },
                  domProps: { value: _vm.firstName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.firstName = $event.target.value
                    }
                  }
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.lastName,
                      expression: "lastName"
                    }
                  ],
                  staticClass: "last-name",
                  attrs: {
                    type: "text",
                    name: "password",
                    placeholder: _vm.$t("language.login.lastName")
                  },
                  domProps: { value: _vm.lastName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.lastName = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.signUpPassword,
                      expression: "signUpPassword"
                    }
                  ],
                  staticClass: "signInInfo",
                  attrs: {
                    type: "password",
                    name: "password",
                    placeholder: _vm.$t("language.login.password")
                  },
                  domProps: { value: _vm.signUpPassword },
                  on: {
                    blur: function($event) {
                      return _vm.passwordVerification()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.signUpPassword = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.nPassword,
                      expression: "nPassword"
                    }
                  ],
                  staticClass: "signInInfo",
                  attrs: {
                    type: "password",
                    name: "password",
                    placeholder: _vm.$t("language.login.confirmPassword")
                  },
                  domProps: { value: _vm.nPassword },
                  on: {
                    blur: function($event) {
                      return _vm.verificationRepeatPassword()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.nPassword = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.verification,
                      expression: "verification"
                    }
                  ],
                  staticClass: "eac-input-wrap",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("language.login.verificationCode")
                  },
                  domProps: { value: _vm.verification },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.verification = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.refresh
                ? _c("img", {
                    staticClass: "verificationCode",
                    attrs: { src: _vm.ficationCode },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.refreshAndClearCode()
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "login-sure" }, [
              _c(
                "button",
                {
                  staticClass: "sign-up",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.signUp()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.login.createAccount")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "continue" }, [
              _vm._v(
                "\r\n            " +
                  _vm._s(_vm.$t("language.login.continueWith")) +
                  "\r\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "login-sure" }, [
              _c(
                "button",
                {
                  staticClass: "google-button",
                  on: {
                    click: function($event) {
                      return _vm.thirdLogin("google_drive")
                    }
                  }
                },
                [_vm._v("Google")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "faceBook-button",
                  on: {
                    click: function($event) {
                      return _vm.thirdLogin("facebook")
                    }
                  }
                },
                [
                  _c("div", {
                    staticClass: "sns-icon facebook",
                    staticStyle: { float: "left" }
                  }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { "line-height": "30px" } }, [
                    _vm._v("Facebook")
                  ])
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line sign-line-bottom" }, [
              _vm._v(
                "\r\n            " +
                  _vm._s(_vm.$t("language.login.creatingAccount"))
              ),
              _c(
                "a",
                {
                  staticClass: "login-link",
                  attrs: {
                    href: "https://www.multcloud.com/terms",
                    target: "_blank"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.login.termsUse")))]
              ),
              _vm._v(","),
              _c(
                "a",
                {
                  staticClass: "login-link",
                  attrs: {
                    href: "https://www.multcloud.com/policy",
                    target: "_blank"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.login.privacyPolicy")))]
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.indexCurrent == 3
        ? _c("div", { staticClass: "sign-success" }, [
            _c("div", { staticClass: "thank-you" }, [
              _vm._v(_vm._s(_vm.$t("language.login.thankYou")))
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(_vm._s(_vm.$t("language.login.checkEmail")) + " ("),
              _c("a", [_vm._v(_vm._s(_vm.messageEmail))]),
              _vm._v(")" + _vm._s(_vm.$t("language.login.confirmRegistration")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "login",
                on: {
                  click: function($event) {
                    return _vm.jumpToLogin()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.login.signIn")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "not-receive" }, [
              _vm._v(_vm._s(_vm.$t("language.login.noteReceiveEmail")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tips" }, [
              _vm._v(
                _vm._s(_vm.$t("language.login.receiveConfirmationEmail")) + " "
              ),
              _c(
                "a",
                {
                  staticClass: "login-link",
                  attrs: { href: "mailto:support@multcloud.com" }
                },
                [_vm._v("support@multcloud.com")]
              ),
              _vm._v(
                _vm._s(_vm.$t("language.login.buttonResend")) + "\r\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "sign-up",
                class: _vm.dis ? "botton-dis" : "",
                attrs: { disabled: _vm.dis },
                on: {
                  click: function($event) {
                    return _vm.reSendmessage(this)
                  }
                }
              },
              [
                _vm._v("Resend\r\n            Confirmation Email"),
                _vm.secondsNum
                  ? _c("span", [_vm._v(" (" + _vm._s(_vm.secondsNum) + ")")])
                  : _vm._e()
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.indexCurrent == 4
        ? _c("div", { staticClass: "sign-success" }, [
            _c("div", { staticClass: "forget-password-title" }, [
              _vm._v(_vm._s(_vm.$t("language.login.forgotPassword")) + " "),
              _c("i", {
                staticClass: "el-icon-back icon-back",
                on: {
                  click: function($event) {
                    _vm.indexCurrent = 0
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("p", { staticStyle: { "font-size": "14px" } }, [
              _vm._v(_vm._s(_vm.$t("language.login.enterEmail")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.forgetEmail,
                      expression: "forgetEmail"
                    }
                  ],
                  staticClass: "signInInfo",
                  attrs: {
                    type: "text",
                    name: "forgetEmail",
                    placeholder: "Email"
                  },
                  domProps: { value: _vm.forgetEmail },
                  on: {
                    blur: function($event) {
                      _vm.emailVerification(), _vm.refreshAndClearCode()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.forgetEmail = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sign-line" }, [
              _c("div", { staticClass: "sign-input" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.verification,
                      expression: "verification"
                    }
                  ],
                  staticClass: "eac-input-wrap",
                  attrs: {
                    type: "text",
                    placeholder: _vm.$t("language.login.verificationCode")
                  },
                  domProps: { value: _vm.verification },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.verification = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.refresh
                ? _c("img", {
                    staticClass: "verificationCode",
                    attrs: { src: _vm.ficationCode },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.refreshAndClearCode()
                      }
                    }
                  })
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "login-sure" }, [
              _c(
                "button",
                {
                  staticClass: "sign-up",
                  on: {
                    click: function($event) {
                      return _vm.sendForgetPassCode()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.login.resetMessage")))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "forgetTips" }, [
              _c("p", { staticClass: "forget-p" }, [
                _vm._v(_vm._s(_vm.$t("language.login.forgetEmail"))),
                _c(
                  "a",
                  {
                    staticClass: "login-link",
                    attrs: { href: "mailto:support@multcloud.com" }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.login.sendEmailSupport")))]
                ),
                _vm._v(
                  _vm._s(_vm.$t("language.login.trackDown")) +
                    "\r\n            "
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("messages", { ref: "messages" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d9df09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d9df09","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = null
// module chunks = 